<template>
  <!-- 导航组 -->
  <div class="diy-navBar" :style="'background:'+itemStyle.background">
    <div :class="'data-list avg-sm-'+itemStyle.rowsNum">
      <div class="item-nav" v-for="(dataItem,index) in datalist" :key="index">
        <div class="nav-to" @click="navigationTo(dataItem.linkUrl)" :data-url="dataItem.linkUrl">
          <div class="item-image">
            <img style="width:100%" :src="dataItem.imgUrl">
          </div>
          <div
            class="item-text f-28 onelist-hidden"
            :style="'color:'+dataItem.color"
          >{{ dataItem.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params","datalist"],
  created() {},
  activated() {},
  methods: {
    navigationTo(url) {
      this.$router.push(url)
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
/* 导航组 */

.diy-navBar .data-list::after {
  clear: both;
  content: " ";
  display: table;
}

.diy-navBar .item-nav {
  float: left;
  margin: 10px 0;
  text-align: center;
}

.diy-navBar .item-nav .item-image {
  margin-bottom: 4px;
  font-size: 0;
}

.diy-navBar .item-nav img {
  width: 44px;
  height: 44px;
}

/* 分列布局 */

.diy-navBar .avg-sm-3 > .item-nav {
  width: 33.33333333%;
}

.diy-navBar .avg-sm-4 > .item-nav {
  width: 25%;
}

.diy-navBar .avg-sm-5 > .item-nav {
  width: 20%;
}
</style>